// src/components/RestaurantGrid/RestaurantGrid.jsx
import React from "react";
import RestaurantCard from "../RestaurantCard/RestaurantCard"; // 👈 verifica la ruta

const RestaurantGrid = ({ items, onOpenDetail, pendingMap }) => {
    const list = Array.isArray(items) ? items : [];
    const alerts = pendingMap && typeof pendingMap === "object" ? pendingMap : {};

    if (list.length === 0) return null;

    return (
        <div className="home-grid">
            {list.map((r) => {
                const id =
                    (r && (r.restauranteId || r.id || r.name)) ? String(r.restauranteId || r.id || r.name) : "";

                const pm = alerts[id] || { has: false, checking: false };

                return (
                    <RestaurantCard
                        key={id || Math.random()}
                        data={r}
                        onOpenDetail={onOpenDetail}
                        hasPending={!!pm.has}          // 👈 alerta de pedidos
                        checkingPending={!!pm.checking}
                    />
                );
            })}
        </div>
    );
};

export default RestaurantGrid;